import { useQuery } from 'react-query';

import type { LoadFileColumnMapping } from '../../../../backend/src/integrations/relativity/load-file-import/load-file-import.entity';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export type { LoadFileColumnMapping };

export type LoadFileImportStatus =
  | 'uploaded'
  | 'parsing'
  | 'mapping'
  | 'queued'
  | 'processing'
  | 'completed'
  | 'failed';

export interface LoadFileImportListItem {
  id: string;
  fileName: string;
  status: LoadFileImportStatus;
  totalRows: number;
  matchedRows: number;
  unmatchedRows: number;
  ambiguousRows: number;
  jobId: string | null;
  errorReason: string | null;
  createdById: string;
  createdDate: string;
  updatedDate: string;
  columnMapping: LoadFileColumnMapping[] | null;
}

/** Lists a matter's `.dat` imports, newest first. */
const useGetLoadFileImports = (matterId: string | undefined, options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getLoadFileImports = async (): Promise<LoadFileImportListItem[]> => {
    const url = `${APIBaseChronos}/api/relativity/load-file-import/list?matterId=${matterId}`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch load file imports: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.LoadFileImports, { matterId }], getLoadFileImports, {
    enabled: enabled && !!matterId,
    refetchOnWindowFocus: false,
  });
};

export default useGetLoadFileImports;
